<template>
	<div class="message-actions small">
		<button aria-label="Copy Message" data-testid="btn-copy" @click="handleCopy">
			<i
				class="bi"
				:class="copied === true ? 'bi-clipboard-check' : 'bi-copy'"
				data-testid="icon-copy"
			></i>
		</button>
		<button
			aria-label="Like Message"
			:disabled="message.liked === true"
			data-testid="btn-like"
			@click="handleLike(true)"
		>
			<i
				class="bi"
				:class="`bi-hand-thumbs-up${message.liked === true ? '-fill' : ''}`"
				data-testid="icon-like"
			></i>
		</button>
		<button
			aria-label="Dislike Message"
			:disabled="message.liked === false"
			data-testid="btn-dislike"
			@click="handleLike(false)"
		>
			<i
				class="bi"
				:class="`bi-hand-thumbs-down${message.liked === false ? '-fill' : ''}`"
				data-testid="icon-dislike"
			></i>
		</button>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { aiService } from '@/services/aiService';
import { logError } from '@/util/logger';
import type { ActionEvent, Message, UserData } from 'Types/aemui/laic-chat/laicChat';

const props = defineProps<{
	message: Message;
	userData: UserData;
}>();

const emit = defineEmits<{
	(e: 'action-event', value: ActionEvent): void;
}>();

const copied = ref(false);

const handleLike = async (value: boolean) => {
	try {
		await aiService.postFeedback(props.userData, {
			messageId: props.message.id,
			liked: value
		});
		emit('action-event', { messageId: props.message.id, liked: value });
	} catch (e: unknown) {
		logError('LAIC post feedback ERROR', {}, e);
	}
};

const handleCopy = async () => {
	if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
		alert('Clipboard is not available');
		return;
	}
	try {
		await navigator.clipboard.writeText(props.message.content);
		copied.value = true;
		setTimeout(() => {
			copied.value = false;
		}, 2000);
	} catch (e: unknown) {
		logError('Clipboard write text ERROR', {}, e);
	}
};
</script>

<style lang="scss" scoped>
.message-actions button {
	border: 0;
	background: transparent;

	&:disabled {
		color: var(--kpl-dark);
	}
}
</style>
